<template>
    <media-album>
        <div class="row u-justify-content--btween _compensate-row-gap">
            <a
                v-for="(data, index) in componentData"
                :key='data.code'
                class="col-default-4 col-tablet-6 col-mobile-12 sg-bg _row-gap"
                :href="data.detailPageUrl"
                @click.prevent="handleClick(data, index)"
            >
                <media-card
                    type="item"
                    :image="data.previewPicture ? data.previewPicture.SRC : ''"
                    :content-type="getContentType(data.mlType.xmlId)"

                />
            </a>
        </div>
        <template v-slot:text>
            <slot/>
        </template>
        <media-library-modal :data="modalData" />
    </media-album>
</template>

<script>
export default {
    name: 'media-album-expedition',
    props: {
        componentData: {
            type: Array,
            required: true
        }
    },
    computed: {
      modalData () {
          return this.componentData.filter((item) => ['video', 'photo'].includes(item.mlType.xmlId))
      }
    },
    methods: {
        getContentType (data) {
            const contentTypes = {
                presentation: ['presentations'],
                interview: ['audio'],
                history: ['history'],
                photo: ['image'],
                video: ['video'],
                finanses: ['results'],
                identity: ['nornik']
            }

            return contentTypes[data]
        },
        handleClick (data, index) {
            if (['photo', 'video'].includes(data.mlType.xmlId)) {
                this.$root.$bus.$emit('open-modal', {id: 'mediaLibraryPopup', index})
            } else if (data.detailPageUrl) {
                window.location.href = data.detailPageUrl
            }
        }
    }
}
</script>
